/**
 * @fileoverview Callout for an error message.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */
import {Button} from '/ui/components/button/button';
import {CalloutBanner, CalloutBannerType} from '/ui/components/calloutbanner/calloutbanner';

/**
 * Callout for an error message.
 * @param {{
 *  onRetry: function(string),
 *  message: string
 * }} props
 * @return {React.ReactNode}
*/
export const ErrorCallout = props => {
  const useDefaultMessage = props.message == '';
  const defaultMessage = yext.msg('There was an error loading this section. Please');
  const displayMessage = useDefaultMessage ? defaultMessage : props.message;

  return (
    <div>
      <CalloutBanner type={CalloutBannerType.ERROR}>
        {displayMessage}&nbsp;
        {useDefaultMessage
          ? <Button chromeless={true} onClick={props.onRetry}>{yext.msg('click to retry.')}</Button>
          : <></>}
      </CalloutBanner>
    </div>
  );
};
